export default "__VITE_ASSET__CTA9x1T4__"